export default "__VITE_ASSET__FKCLvSsa__"